<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
          <h2>🌟 StingyCat's Airborne Adventure through Norbert’s Gambit for USD/CAD FX Conversions🌟</h2>

<p>Fasten your seatbelts, frugal felines! Captain StingyCat here, ready to whisk you away on a savvy saver’s journey from TSX to NYSE. Prepare for a clever currency conversion adventure with Norbert’s Gambit, where we navigate from the Canadian financial runway to the bustling American stock market terminal.</p>

<iframe height="650" style="width: 100%;" scrolling="no" title="Air Canada Boarding Pass" src="https://codepen.io/Farah-Kamal/embed/JjzOqXj?default-tab=result&theme-id=47174" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true"></iframe>

<p>🛫 Boarding at TSX: The Stock Market Gate (Purchasing Shares)
Our flight begins at gate TSX, where we're on the prowl for the purr-fect stock ticket – a dual-listed company trading in CAD and USD. It’s like choosing the best window seat for your journey – we aim for comfort (liquidity) and a smooth ride (low volatility).  </p>

<p>🌐 Soaring Over Borders: The Airborne Transfer (Journaling Shares)
As we cruise above the clouds, we execute a sleek mid-air transfer, journaling our shares from TSX to NYSE. Imagine us, nimble cats, leaping gracefully from one market to another, smoothly crossing the financial border. </p>

<p>✈️ Navigating Financial Skies: Eagle-Eyed for Changes (Capital Gains and Taxes)
In our financial flight, we keep a watchful eye on any fluctuations – akin to potential capital gains tax if our shares climbed in value. And don't forget the U.S. withholding tax on dividends, a consideration when holding U.S. stocks.</p>
       
<p>🛬 Landing at NYSE: Converting Currencies on the Runway (Selling Shares in USD)
Touching down at NYSE, we swiftly sell our shares, converting our Canadian dollars into U.S. dollars. It's as graceful and efficient as a cat landing on all four paws after a daring leap!</p>

<p>🐾 Choosing the Right Airline: Broker Selection
Just as you’d pick the best airline for your journey, choosing the right brokerage is key for Norbert’s Gambit. While some, like RBC Direct Investing, offer a first-class experience with easy journaling, others might not support this savvy traveler’s route.</p>

<p>💸 Buying currency at the airport is like paying for gourmet tuna but getting canned fish instead – outrageously expensive and wholly unsatisfying!" - StingyCat</p>

<p>💰 When you exchange currency through a bank or broker, they often add a sneaky 2.5% fee to the rate. This means if you're buying USD with CAD, you pay 2.5% more than the market rate. Conversely, when selling USD for CAD, you receive 2.5% less. It's like a hidden tax on your transactions, nibbling away at your funds like a sly alley cat!</p>

<p class="domestic-tip">
        🐱 For those looking to stay domestic on the TSX, a popular method involves utilizing DLR.U and DLR. To learn more about this approach, check out the product details 
        <a href="https://horizonsetfs.com/ETF/dlr-u/#product-facts" target="_blank">here</a>.
    </p>

<p>🤔 To Fly or Not to Fly?
Embarking on the TSX-NYSE express via Norbert’s Gambit is a decision that requires weighing the costs and benefits. It's like a cat deciding whether to chase a mouse or lounge in the sun – consider all the factors before you leap.

Thank you for choosing StingyCat Airways for your financial journey. We pride ourselves on navigating the most efficient and value-packed routes in the financial skies!  This method is useful if you are converting larger amounts of money and are not in a rush as you have to wait until the stock settles, then journal the shares.  Factor in having a cat nap and estimating 4-5 business days for this all to go through.</p>

<p>Till our next frugal flight,
Captain StingyCat 🐾</p>
<img class="stingycat-image" :src="require('@/assets/stingycat-airplane.png')" alt="StingyCat on a plane, embarking on a journey to save on currency conversion fees with Norbert’s Gambit" />

<div class="norberts-gambit-calculator">
    <h2>Norbert's Gambit Savings Calculator</h2>

    <div class="calculator-inputs">
    <div class="input-group">
      <label for="amountCAD">Amount to Convert (CAD):</label>
      <input type="number" id="amountCAD" v-model.number="amountCAD" placeholder="Amount in CAD" @input="calculateGambit"/>
    </div>

    <div class="input-group">
      <label for="brokerageFee">Commission (CAD):</label>
      <input type="number" id="brokerageFee" v-model.number="brokerageFee" placeholder="Brokerage Fee" @input="calculateGambit"/>
    </div>

    <div class="input-group">
      <label for="exchangeRate">USD/CAD Exchange Rate:</label>
      <input type="number" id="exchangeRate" v-model.number="usdCadRate" placeholder="Exchange Rate" step="0.00001" @input="calculateGambit"/>
    </div>

    <div class="input-group">
      <label for="percentFee">Input % Fee Charged (e.g., 2.5):</label>
      <input type="number" id="percentFee" v-model.number="percentFee" placeholder="% Fee" step="0.1" @input="calculateGambit"/>
    </div>

    <div class="input-group">
      <label for="dlrPriceCAD"> Inter-listed Stock Price (CAD):</label>
      <input type="number" id="dlrPriceCAD" v-model.number="dlrPriceCAD" placeholder="Price in CAD" @input="calculateGambit"/>
    </div>

    <div class="input-group">
      <label for="dlrPriceUSD">Inter-listed Stock Price (USD):</label>
      <input type="number" id="dlrPriceUSD" v-model.number="dlrPriceUSD" placeholder="Price in USD" @input="calculateGambit"/>
    </div>
    <button class="calculate-btn" @click="calculateGambit">Calculate</button>

    <table class="calculator-results-table">
        <tbody>
                <tr>
                    <td>Proceeds with Norbert's Gambit:</td>
                    <td>{{ gambitConversion.toFixed(2) }} USD</td>
                </tr>
                <tr>
                    <td>Proceeds without Norbert's Gambit:</td>
                    <td>{{ directConversionCost.toFixed(2) }} USD</td>
                </tr>
                <tr>
                    <td>Cost if Converted at Airport:</td>
                    <td>{{ airportConversionCost.toFixed(2) }} USD</td>
                </tr>
                <tr class="savings-row">
                    <td>Funds Saved Using Norbert's Gambit:</td>
                    <td>{{ savings.toFixed(2) }} USD</td>
                </tr>
            </tbody>
        </table>
        <p class="disclaimer">
            *<i>All of the calculations above are estimates and are intended for educational purposes only. If you do save money through this method StingyCat would love to hear from you about how much you saved.</i>
        </p>
    </div>

  </div>


</div></div>
</div><br><br><br><br><br><br>
</template>


<script>
import { ref, computed } from 'vue';

export default {
  setup() {
    const amountCAD = ref(10000);
    const brokerageFee = ref(9.95);
    const usdCadRate = ref(1.345);
    const percentFee = ref(2.5);
    const dlrPriceCAD = ref(13.59);
    const dlrPriceUSD = ref(10.12);

    const gambitConversion = computed(() => {
      if (usdCadRate.value && dlrPriceCAD.value && dlrPriceUSD.value && amountCAD.value) {
        const dlrShares = amountCAD.value / dlrPriceCAD.value;
        return (dlrShares * dlrPriceUSD.value) - (brokerageFee.value * 2);
      }
      return 0;
    });

    const directConversionCost = computed(() => {
      if (usdCadRate.value && amountCAD.value) {
        return (amountCAD.value / usdCadRate.value) * (1 - percentFee.value / 100);
      }
      return 0;
    });

    const savings = computed(() => {
      return gambitConversion.value - directConversionCost.value;
    });

    const airportConversionCost = computed(() => {
      if (usdCadRate.value && amountCAD.value) {
        return (amountCAD.value / usdCadRate.value) * 0.9; // 10% markup
      }
      return 0;
    });

    return {
      amountCAD,
      brokerageFee,
      usdCadRate,
      percentFee,
      dlrPriceCAD,
      dlrPriceUSD,
      gambitConversion,
      directConversionCost,
      savings,
      airportConversionCost
    };
  },
};
</script>

<style scoped>
.wrapper {
display: flex;
flex-direction: column;
align-items: center;
}

.content-container {
background-color: #4A148C ; 
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}

.stylish-links {
background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
color: #333;
font-size: 1.4em;
margin-bottom: 15px;
}

.stylish-links ul {
list-style: none;
padding: 0;
}

.stylish-links ul li {
background-color: #fff;
margin: 10px 0;
padding: 10px;
border-radius: 8px;
box-shadow: 0 2px 4px rgba(0,0,0,0.1);
transition: all 0.3s ease;
}

.stylish-links ul li a {
color: black;
text-decoration: none;
font-weight: bold;
}

.stylish-links ul li:hover {
background-color: #4A148C;
}

.stylish-links ul li:hover a {
color: #fff;
}

.stingycat-image {
    max-width: 100%; /* Makes the image responsive */
    height: auto; /* Maintain aspect ratio */
    display: block; /* Align image nicely */
    margin: 0 auto; /* Center image */
}

.norberts-gambit-calculator {
        max-width: 500px;
        margin: 10px auto;
        padding: 10px;
        background-color: #f8f8f8;
        border-radius: 10px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .calculator-inputs {
        display: grid;
        gap: 5px;
    }
    .calculator-results-table {
        width: 100%;
        margin-top: 20px;
        border-collapse: collapse;
    }

    .calculator-results-table td {
        padding: 6px;
        border: 1px solid #ccc;
    }

    .savings-row {
        font-weight: bold;
        background-color: #e8e8e8;
    }

    .disclaimer {
        margin-top: 10px;
        font-size: 0.9em;
        color: #666;
    }

    .input-group {
        display: flex;
        flex-direction: column;
    }

    input[type="number"] {
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 5px;
    }

    .calculate-btn {
      background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
    }

    .calculate-btn:hover {
      background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
    }

    .calculator-results {
        margin-top: 20px;
        font-weight: bold;
    }

    @media (max-width: 600px) {
        .norberts-gambit-calculator {
            width: 90%;
        }
    }


button {
    background-color: #4A148C; /* Purple background */
    color: white; /* White text */
    border: none;
    border-radius: 20px; /* Rounded corners */
    padding: 10px 20px; /* Padding inside the button */
    cursor: pointer; /* Cursor style */
    transition: background-color 0.3s ease; /* Smooth transition for hover effect */
  }
  
  button:hover {
    background-color: black; /* Black background on hover */
  }

/* Media query for mobile devices */
@media (max-width: 600px) {
    .content-container {
        padding: 10px;
    }
    .stingy-card {
        padding: 10px;
    }
    h2 {
        font-size: 1.2em; /* Smaller font size for headings */
    }
    p {
        font-size: 0.9em; /* Smaller font size for paragraphs */
    }
}
</style>